var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[_c('el-row',{attrs:{"type":"flex","gutter":10,"justify":"end"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"el-col-box chart"},[_c('date')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }